import { LoaderService } from 'app/services/loader.service';
import { SessionService } from 'app/services/session.service';
import { Globals } from 'app/globals';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoaderGuard  {
  constructor(public sessionService: SessionService, public router: Router, private loaderService: LoaderService, private globals: Globals) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    this.loaderService.setLoadingContent(!this.globals.inferSkeletonTemplate(state?.url || this.router.url));
    return true;
  }
}